import $ from 'jquery';

export function checkboxChange() {
  $(':checkbox').change(function() {
    if (this.checked) {
      this.value = 'active'
    } else {
      this.value = 'inactive'
    }
  });
  $('#hasWassenger').change(function(){
    $('#wassengerToken').prop('disabled', !this.checked);
    $('#phoneNumber').prop('disabled', !this.checked);
    $('#wassengerDeviceId').prop('disabled', !this.checked);
  })
}
